import { isIos } from "@repo/edtech-shared";

import { GlobalPlayerStore, MiniActions } from "../../types";

export const createMiniPlayerSlice = (store: GlobalPlayerStore): MiniActions => {
  return {
    toggleMini: () => {
      store.set({
        isMini: !store.get().isMini,
      });
    },

    enterMini: () => {
      store.set({
        isMini: true,
      });
    },

    exitMini: () => {
      store.set({
        isMini: false,
      });
    },

    setMiniBackButtonHandler(fn) {
      store.set({
        onBackHandler: fn,
      });
      return () => {
        if (store.get().onBackHandler === fn) {
          store.set({
            onBackHandler: undefined,
          });
        }
      };
    },

    setMiniExitButtonHandler(fn) {
      store.set({
        onExitHandler: fn,
      });
      return () => {
        if (store.get().onExitHandler === fn) {
          store.set({
            onExitHandler: undefined,
          });
        }
      };
    },

    triggerMiniBackButton(onClickFromUI) {
      onClickFromUI?.();
      store.get().onBackHandler?.();
      store.miniActions.exitMini();
    },

    handleMiniPlayer: async () => {
      const el = store.playerActions.getPlayerElement();
      if(!el) return;

      const exitFullscreenIfNeeded = async () => {
        if (store.get().isFullscreen) {
          try {
            await document.exitFullscreen?.();
            // eslint-disable-next-line
            (document as any).webkitExitFullscreen?.();
            // eslint-disable-next-line
            (document as any).mozCancelFullScreen?.();
            // eslint-disable-next-line
            (document as any).msExitFullscreen?.();
            store.controlsActions.setFullscreen(false);
          } catch (err) {
            console.warn("Exit fullscreen error:", err);
          }
        }
      };

      if (!isIos()) {
        await exitFullscreenIfNeeded();
        store.miniActions.enterMini();
      } else {
        try {
          if (document.pictureInPictureEnabled && !document.pictureInPictureElement) {
            await (el as HTMLVideoElement).requestPictureInPicture();
          } else {
            store.miniActions.enterMini();
          }
        } catch (err) {
          console.error("PiP error:", err);
          store.miniActions.enterMini();
        }
      }
    },
  };
};
